var $ = require('../internals/export');
var from = require('../internals/collection-from');

// `Map.from` method
// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
$({
  target: 'Map',
  stat: true,
  forced: true
}, {
  from: from
});